import React, { useMemo } from 'react'
import { createContext } from 'lib/createContext'
import { useDayforceAgenciesQuery } from 'queries/admin/dayforce/useDayforceAgenciesQuery'
import { DayforceAgency } from 'api/admin/dayforce/listDayforceAgencies'

type DayforceAgenciesMap = Record<string, DayforceAgency>

type DayforceAgenciesContextValue = {
  state: {
    agencies: DayforceAgenciesMap
    isPending: boolean
    isError: boolean
  }
  actions: {
    refetch: () => void
  }
}

const [Context, useDayforceAgenciesContextValue] =
  createContext<DayforceAgenciesContextValue>({
    name: 'DayforceAgenciesContext',
  })

function itemsToMap(items: DayforceAgency[]): DayforceAgenciesMap {
  return items.reduce<DayforceAgenciesMap>((acc, agency) => {
    acc[agency.id] = agency
    return acc
  }, {})
}

export const DayforceAgenciesProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { data, isPending, isError, refetch } = useDayforceAgenciesQuery()

  const agencies = useMemo(() => itemsToMap(data?.items ?? []), [data?.items])

  const value: DayforceAgenciesContextValue = {
    state: {
      agencies,
      isPending,
      isError,
    },
    actions: {
      refetch: () => {
        void refetch()
      },
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useDayforceAgenciesContextValue }
